import { motion } from 'framer-motion';
import davinciLogo from '../assets/davinci resolve logo.png';
import premiereLogo from '../assets/premiere-pro.png';
import afterEffectsLogo from '../assets/after-effects_5968428.png';
import photoshopLogo from '../assets/photoshop.png';
import illustratorLogo from '../assets/illustrator.png';

const tools = [
  {
    name: 'DaVinci Resolve',
    logo: davinciLogo,
  },
  {
    name: 'Adobe Premiere Pro',
    logo: premiereLogo,
  },
  {
    name: 'Adobe After Effects',
    logo: afterEffectsLogo,
  },
  {
    name: 'Adobe Photoshop',
    logo: photoshopLogo,
  },
  {
    name: 'Adobe Illustrator',
    logo: illustratorLogo,
  },
];

export default function ToolsCarousel() {
  // creates enough duplicates to span 4k screens seamlessly
  const duplicatedTools = Array(10).fill(tools).flat();

  return (
    <div className="relative w-full overflow-hidden py-12">
      {/* Left gradient fade */}
      <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-black to-transparent z-10 pointer-events-none" />

      {/* Right gradient fade */}
      <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-black to-transparent z-10 pointer-events-none" />

      {/* Scrolling container */}
      <motion.div
        className="flex gap-16 items-center"
        animate={{
          x: ["0%", "-50%"],
        }}
        transition={{
          x: {
            repeat: Infinity,
            repeatType: "loop",
            duration: 30,
            ease: "linear",
          },
        }}
        whileHover={{
          animationPlayState: "paused",
        }}
        style={{
          width: 'max-content',
        }}
      >
        {duplicatedTools.map((tool, index) => (
          <motion.div
            key={`${tool.name}-${index}`}
            className="flex-shrink-0 opacity-60 hover:opacity-100 transition-opacity duration-300"
            whileHover={{ scale: 1.1 }}
          >
            <div className="flex flex-col items-center gap-3">
              <img
                src={tool.logo}
                alt={tool.name}
                className="h-16 w-auto object-contain drop-shadow-lg"
              />
              <span className="text-white/60 text-sm font-semibold tracking-wide whitespace-nowrap">
                {tool.name}
              </span>
            </div>
          </motion.div>
        ))}
      </motion.div>
    </div>
  );
}
